import * as React from 'react';

import {LoadingPage} from 'shells/loading-page/loading-page';

import {useGetMeeting} from './graphql/hooks/use-get-meeting';
import {PeanutScheduler} from './peanut-scheduler';
import {useGetPeanutSchedulerConfig} from './use-get-peanut-scheduler-config';

import styles from './meeting-preview.module.css';

type Props = {
    meetingId: string;
};

export function MeetingPreview(props: Props) {
    const {meeting} = useGetMeeting(props.meetingId);

    const {schedulerConfig} = useGetPeanutSchedulerConfig(
        meeting ? meeting.modelId : null,
        NutshellFrontendSettings.instanceId
    );

    return meeting ? (
        <>
            <div className={styles['preview-text']}>Meeting Preview:</div>
            {schedulerConfig ? (
                <div className={styles['preview-container']}>
                    <PeanutScheduler
                        schedulerConfig={JSON.stringify(schedulerConfig)}
                        meetingModelId={meeting.modelId}
                        viewType='interactive'
                    />
                </div>
            ) : (
                <LoadingPage padding={0} />
            )}
        </>
    ) : null;
}
